{
  "fr": {
    "linkShortener": {
      "hints": {
        "copied": "Copié dans le presse-papiers !",
        "shortcode": "Nous avons généré une URL aléatoire pour vous. Entrez ici votre URL souhaitée"
      },
      "labels": {
        "shortcode": "Lien court",
        "url": "URL"
      }
    }
  }
}
